import React from 'react';
import Hero from '../components/hero';
import styles from './index.module.scss';

export default ({ data }) =>
  <Hero>
    <div dangerouslySetInnerHTML={{ __html: data.contentfulSection.content.childMarkdownRemark.html }} />
  </Hero>

export const query = graphql`
  query homepageQuery {
    contentfulSection(contentfulid: {eq: "homepage"}) {
      content {
        childMarkdownRemark {
          html
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js